import Skeleton from "react-loading-skeleton";

import styles from "./IntegrationConfigurationPanel.module.scss";

export const IntegrationConfigurationPanelSkeleton = () => {
  return (
    <div>
      <div className={styles.formRow}>
        <Skeleton height={20} width={120} />
        <Skeleton height={42} containerClassName={styles.fullWidth} />
      </div>
      <div className={styles.formRow}>
        <Skeleton height={20} width={140} />
        <Skeleton height={42} containerClassName={styles.fullWidth} />
      </div>
    </div>
  );
};
